/* Good Tree — standalone PDP variant selection + add-to-cart.
   Vanilla, no libraries. Mirrors Dawn's approach (read selected option radios,
   match against the product's variant JSON, update the hidden variant id, price,
   and submit-button state) but without depending on Dawn's custom elements. */
(function () {
  'use strict';

  function money(cents, format) {
    // Minimal Shopify-style money formatter. `format` is the shop money_format
    // with the {{ }} placeholders already reduced to a token by Liquid.
    var amount = (cents / 100).toFixed(2);
    if (format) {
      return format
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(cents / 100)))
        .replace(/\{\{\s*amount(_with_comma_separator|_no_decimals_with_comma_separator)?\s*\}\}/g, amount);
    }
    return '$' + amount;
  }

  function initRoot(root) {
    var variantsTag = root.querySelector('[data-pdp-variants]');
    if (!variantsTag) return;

    var variants;
    try {
      variants = JSON.parse(variantsTag.textContent);
    } catch (e) {
      return;
    }

    var moneyFormat = root.getAttribute('data-money-format') || '';
    var idInput = root.querySelector('[data-pdp-variant-id]');
    var priceEl = root.querySelector('[data-pdp-price]');
    var addBtn = root.querySelector('[data-pdp-add]');
    var addLabel = addBtn ? addBtn.querySelector('[data-pdp-add-label]') : null;
    var optionInputs = root.querySelectorAll('[data-pdp-option]');

    function selectedOptions() {
      var opts = [];
      optionInputs.forEach(function (input) {
        if (input.checked) {
          var pos = parseInt(input.getAttribute('data-option-position'), 10);
          opts[pos - 1] = input.value;
        }
      });
      return opts;
    }

    function matchVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (val, i) {
          return val === opts[i];
        });
      }) || null;
    }

    function setActiveChip(input) {
      var name = input.getAttribute('name');
      root.querySelectorAll('[data-pdp-option][name="' + name + '"]').forEach(function (sib) {
        var label = root.querySelector('label[for="' + sib.id + '"]');
        if (label) label.classList.toggle('is-active', sib.checked);
      });
    }

    function update() {
      var opts = selectedOptions();
      var variant = matchVariant(opts);

      if (idInput && variant) idInput.value = variant.id;

      if (priceEl && variant) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceEl.innerHTML =
            '<s class="gt-price__was">' + money(variant.compare_at_price, moneyFormat) + '</s> ' +
            money(variant.price, moneyFormat);
        } else {
          priceEl.textContent = money(variant.price, moneyFormat);
        }
      }

      if (addBtn) {
        if (!variant) {
          addBtn.setAttribute('disabled', 'disabled');
          if (addLabel) addLabel.textContent = 'Unavailable';
        } else if (!variant.available) {
          addBtn.setAttribute('disabled', 'disabled');
          if (addLabel) addLabel.textContent = 'Sold out';
        } else {
          addBtn.removeAttribute('disabled');
          if (addLabel) addLabel.textContent = 'Add to bag →';
        }
      }

      // Update the URL so a refresh keeps the selection (matches Dawn behaviour).
      if (variant && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        setActiveChip(input);
        update();
      });
    });

    update();

    // AJAX add to cart so the buy flow stays on-page; falls back to a normal
    // form POST if fetch is unavailable.
    var form = root.querySelector('[data-pdp-form]');
    if (form && window.fetch) {
      form.addEventListener('submit', function (evt) {
        evt.preventDefault();
        if (addBtn) {
          addBtn.setAttribute('disabled', 'disabled');
          if (addLabel) addLabel.textContent = 'Adding…';
        }
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
          })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
            if (addLabel) addLabel.textContent = 'Added ✓';
            setTimeout(update, 1400);
          })
          .catch(function () {
            update();
            form.submit();
          });
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-pdp-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
